import React from 'react';
import LogoMarqueeWithTitleAndStats from './LogoMarqueeWithTitleAndStats';

const LogoMarqueeWithTitleAndStatsWithProps = (props: any) => {
  return (
    <LogoMarqueeWithTitleAndStats
      sectionTitle={props.sectionTitle}
      sectionDescription={props.sectionDescription}
      marqueeLogos={props.marqueeLogos}
      statItems={props.statItems}
    />
  );
};

export default LogoMarqueeWithTitleAndStatsWithProps;
